import React, { Component } from 'react';
import { Button, Form, Modal, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import Resources from '../scripts/resources';
import Rules from '../scripts/rules';

class UploadForm extends Component {
    constructor() {
        super();

        this.state = {
            fileList: [],
            fileData: {},
            productId: ''
        };

        this.formRef = React.createRef();
    }

    handleSubmit = () => {
        this.formRef.current.validateFields()
            .then(values => {
                const { fileData, productId } = this.state;
                const formData = new FormData();

                formData.append('product_id', productId);
                formData.append('images[]', fileData, fileData.name);

                this.props.onSubmit(formData);
            });
    }

    handleWillUnmount = () => {
        this.formRef.current.resetFields();

        this.setState({ fileList: [] });
    }

    handleDidMount = (pId) => {
        this.setState({ productId: pId });
    }

    render() {
        const { onCancel, submitting, visible } = this.props;
        const { fileList } = this.state;

        const props = {
            onRemove: file => {
                this.setState(state => {
                    const index = state.fileList.indexOf(file);
                    const newFileList = state.fileList.slice();
                    newFileList.splice(index, 1);
                    return { fileList: newFileList };
                });
            },
            beforeUpload: file => {
                this.setState({ fileList: [file], fileData: file });
                return false;
            },
            fileList
        };

        return (
            <Modal
                title={`${Resources.add} ${Resources.image}`}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={onCancel}
                okText={Resources.confirm}
                cancelText={Resources.cancel}
                okButtonProps={{ loading: submitting }}
                cancelButtonProps={{ disabled: submitting }}
                width={360}>
                <Form ref={this.formRef} layout="vertical">
                    <Form.Item name="image" label={Resources.image} rules={Rules.required}>
                        <Upload {...props} className="ant-upload-block">
                            <Button block><UploadOutlined /> {Resources.chooseImage}</Button>
                        </Upload>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
};

export default UploadForm;